import React, { useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';
import { FaRegTrashAlt } from 'react-icons/fa';
import { BsDot } from 'react-icons/bs';
import { ObjModal } from '../../../../contexts';
import AddGift from '../../../Modals/AddGift';

import { styled } from '@mui/material/styles';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import MuiAccordionSummary from '@mui/material/AccordionSummary';


const GiftRecipients = ( { aid, uid, contacts } ) => {
    const { objType, obj, openModal, closeModal, setModal } = useContext( ObjModal );
    const [ expanded, setExpanded ] = useState( false );

    useEffect( () => {
        setExpanded( obj.recipients.length > 0 );
    }, [ obj.recipients ] );

    const formatName = ( cid ) => {
        const c = contacts.find( con => con.cid === cid );
        return ( c ) ? c.firstname + ' ' + c.lastname : null;
    };

    const trash = async ( grid ) => {
        // await remove( { aid: aid, uid: uid, cid: c.details.cid, gid: gid } );
        alert( 'need to trash: ' + grid );
    };

    const handleModal = ( t ) => {
        let shouldOpen = true;

        switch ( t ) {
            case 'gift':
                setModal( <AddGift close={closeModal} /> ); 
                break;

            default:
                console.log( 'Unknown modal type: ' + t );
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const AccordionSummary = styled( ( props ) => (
        <MuiAccordionSummary expandIcon={<KeyboardArrowRightSharpIcon sx={{ fontSize: '0.9rem' }} />} {...props} />
    ) ) ( ( { theme } ) => ( {
        backgroundColor:
          theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
        flexDirection: 'row-reverse',
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)',
        },
        '& .MuiAccordionSummary-content': {
            marginLeft: theme.spacing(1),
        },
    } ) );

    return (
        <Container fluid className='p-0'>
            <Accordion expanded={expanded}>
                <AccordionSummary expandIcon={<KeyboardArrowRightSharpIcon onClick={ () => setExpanded( !expanded ) } />}>
                    <Row className='align-items-center w-100'>
                        <Col><Typography>Recipients ({obj.recipients.length})</Typography></Col>
                        <Col xs='auto' className='p-0'><Button variant='outline-primary' size='sm' onClick={ () => handleModal( 'gift' ) }>+ Add</Button></Col>
                    </Row>
                </AccordionSummary>
                <AccordionDetails>
                    <ListGroup variant='flush'>
                    { obj.recipients.map( ( r, idx ) => (
                        <ListGroup.Item key={idx}>
                            <Row className='align-items-center'>
                                <Col className='p-1'>
                                    <Link to={`/contact/${r.cid}`}>{formatName( r.cid )}</Link>
                                </Col>
                                <Col xs='auto'><FaRegTrashAlt className='tf-sidebar-trash' onClick={ () => trash( r.grid ) } /></Col>
                            </Row>
                        </ListGroup.Item>
                    ) ) }
                    </ListGroup>
                </AccordionDetails>
            </Accordion>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    contacts: state.user.lists.contacts
} );

const mapDispatch = ( dispatch ) => ( {
    // loadTasks: dispatch.contacts.loadContactTasks,
} );

export default connect( mapProps, mapDispatch )( GiftRecipients );